import React from "react";
import styled from "styled-components";
import AddIconSrc from "../../../../../images/icons/add-icon.svg";
import Tabs from "../../../Components/Main/Sidebar/Tabs";
import Tab from "../../../Components/Main/Sidebar/Tab";
import TabContent from "../../../Components/Main/Sidebar/TabContent";
import MenuButton from "../../../Components/Main/Sidebar/MenuButton";
import MenuSearchInput from "../../../Components/Main/Sidebar/MenuSearchInput";
import TabContentLoading from "../../../Components/Main/Sidebar/TabContentLoading";
import AddIcon from "../../../Components/Main/Sidebar/AddIcon";
import api from '../../../../util/api';
import sanitizeNoteHtml from '../../../../util/sanitizeNoteHtml';
import ModalOption from "../../../Components/Main/Modals/ModalOption";
import MenuSelect from "../../../Components/Main/Modals/MenuSelect";
import {ToastContainer, toast} from 'react-toastify';
import ThreeDotMenuIcon from "../../../../../images/icons/3-dot-menu-icon.png";
import SelectedStarIcon from "../../../../../images/icons/selected-star-icon.png";
import UnselectedStarIcon from "../../../../../images/icons/unselected-star-icon.png";
import SharedLabel from "../../../Components/Main/Sidebar/SharedLabel";


const Pagination = styled.div`
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    padding-bottom: 20px;
    background: white;
    padding-top: 20px;
    
    
    .pagination-pages > span:not(.visible) {
        display: none;
    }
`;

const PaginationRefresh = styled.a`
    text-decoration: underline;
    text-align: center;
    width: 100%;
    display: block;
    font-size: 14px;
    color: #888888;
    cursor: pointer;
`;

const Pages = styled.div`
    text-align: center;
    margin-top: 20px;    
`;

const PageArrow = styled.span`
    color: #888888;
    font-size: 23px;
    padding: 0 7px;
    line-height: 32px;
`;

const Page = styled.span`
    color: #888888;
    font-size: 23px;
    padding: 0 7px;
    line-height: 32px;
    cursor: pointer;
    
    ${(props) => (props.active ? {
    'background': '#5562C0',
    'color': 'white',
    'width': '30px',
    'height': '30px',
    'display': 'inline-block !important',
    'border-radius': '45px',
} : '')}
`;

const NoteMenuWrapper = styled.section`
    display: none;
    background: white;
    
    ${(props) => (props.open ? {
    'display': 'block'
} : '')}
`;
const NotesList = styled.div`
`;

const Note = styled.div`
    background: #EDEDED;
    padding: 21px;
    margin-bottom: 15px;
    text-decoration: none;
    color: black;
`;
const NoteContent = styled.div`
    font-size: 15px;
`;

const NoteContentTruncated = styled.div`
    font-size: 15px;
    cursor: pointer;
`;

const NoteHeading = styled.h3`
    font-size: 16px;
    font-weight: 700;
    line-height: 21px;
    margin: 0;
    padding: 0;
    position: relative;
    
    padding-right: 110px;
`;

const NoteVideo = styled.div`
    font-size: 18px;
    color: #515151;
    // font-family: 'Proxima-Nova-Semibold';
`;
const NotePdf = styled.div`
    font-size: 18px;
    color: #515151;
    // font-family: 'Proxima-Nova-Semibold';
`;

const FontAwesomeIcon = styled.i`
color: #515151;
    margin-right: 15px;
    top: 1px;
    position: relative;
    cursor: pointer;
        display: ${(props) => (props.hidden ? "none" : "inline-block")};
`;
const NoteSubheading = styled.p`
        font-size: 12px;
    line-height: 17px;
    color: gray;
    margin-top: 6px;
`;


const FavoriteTrigger = styled.div`
    float: right;
    height: 18px;
    position: absolute;
    top: 28px;
    right: 0;
    cursor: pointer;
    width: 20px;
    
    img {
        width: 100%;
    }
`;

const PaginationResults = styled.div`
    
    color: #888888;
    font-size: 14px;
    text-align: center;
    border-top: 1px solid lightgrey;
    padding-top: 20px;
    padding-bottom: 20px;
    margin-top: -10px;
`;

const ThreeDotMenuClose = styled.div`

    position: absolute;
    top: 6px;
    right: 6px;
    cursor: pointer;
    color: grey;
`;

const ThreeDotMenuTrigger = styled.img`
    float: right;
    height: 18px;
    position: absolute;
    top: 0;
    right: 7px;
    cursor: pointer;
`;

const SortWrapper = styled.div`
    overflow: auto;
    width: 100%;
`;

const NoteName = styled.span`
    cursor: pointer;
    font-weight: 700;
`;

const SortLabel = styled.span`   
 width: 35%;
    float: left;
    font-size: 18px;
    color: #737697;
    padding-top: 19px;
`;

const SortInputWrapper = styled.span`
width: 65%;
float: left;
`;

const ThreeDotMenu = styled.div`
    top: 0;
    right: 0;
    
    position: absolute;
    background: white; 
    border: 2px solid lightgrey;
    padding: 10px;
    box-shadow: 5px 5px 25px #0000002e;
    display: none;   
    z-index: 9;
   
    
    
    ${(props) => (props.open ? {
    'display': 'block'
} : '')}
`;

const ThreeDotMenuItem = styled.div`
        display: ${(props) => (props.hidden ? "none" : "block")};

    margin-bottom: 6px;
    border-bottom: 1px solid lightgrey;
    padding-bottom: 6px;
    width: 145px;
    cursor: pointer;
    
    
    ${(props) => (props.no_border ? {
    'border': 'none !important',
    'margin': '0 !important',
    'padding': '0 !important'
} : '')}
`;


export default class NotesMenu extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            tab_open: !this.props.lesson_id || (this.props.lesson_id && !this.props.isInstructor) ? 2 : 1,
            three_dot_menu_open: null
        };
    }

    setTab(val) {
        this.setState({tab_open: val});
    }

    setThreeDotMenuOpen(val) {
        this.setState({three_dot_menu_open: val});
    }

    render() {
        return (
            <NoteMenuWrapper open={this.props.open}>
                <Tabs>
                    <Tab hidden={!this.props.lesson_id || (this.props.lesson_id && !this.props.isInstructor)}
                         onClick={() => {this.setTab(1)}} open={this.state.tab_open === 1}>{"Student Notes"}</Tab>
                    <Tab fullwidth={!this.props.lesson_id} onClick={() => {this.setTab(2)}}
                         open={this.state.tab_open === 2}>{"Notes Library"}</Tab>
                </Tabs>
                <TabContent open={this.state.tab_open === 1}>
                    <TabContentLoading open={this.props.notesLoading}><i
                        className="fa fa-spinner"></i></TabContentLoading>
                    <MenuButton onClick={this.props.newLessonNoteAction}>
                        <AddIcon src={AddIconSrc}/>
                        {"Create New Note"}
                    </MenuButton>
                    <MenuSearchInput onKeyDown={this.props.searchLessonNotes} onChange={this.props.searchLessonNotes}
                                     placeholder="Search Notes"></MenuSearchInput>


                    <SortWrapper>
                        <SortLabel>Sort By:</SortLabel>
                        <SortInputWrapper>
                            <MenuSelect onChange={(e) => {this.props.selectSort(e, 'lessonNotes')}}>
                                <ModalOption value="created_at">Created Date</ModalOption>
                                <ModalOption value="name">Name</ModalOption>
                            </MenuSelect>
                        </SortInputWrapper>
                    </SortWrapper>
                    {this.props.studentPaginationMeta ? (
                        <PaginationResults>showing {this.props.lessonNotes.length} of {this.props.studentPaginationMeta.total} results</PaginationResults>
                    ) : (
                        <></>
                    )}
                    <NotesList>
                        {Object.keys(this.props.lessonNotes).map((item, index) => (
                            <Note key={this.props.lessonNotes[item].id}>
                                <NoteHeading>
                                    <NoteName>
                                        {this.props.lessonNotes[item].favorite && (
                                            <FontAwesomeIcon className="fas fa-thumbtack" style={{marginRight:'6px'}}></FontAwesomeIcon>
                                        )}
                                        {this.props.lessonNotes[item].name}
                                    </NoteName>

                                    <ThreeDotMenuTrigger
                                        onClick={() => {this.setThreeDotMenuOpen(this.props.lessonNotes[item].id)}}
                                        src={ThreeDotMenuIcon}></ThreeDotMenuTrigger>
                                    <ThreeDotMenu
                                        open={this.state.three_dot_menu_open == this.props.lessonNotes[item].id}>
                                        <ThreeDotMenuClose
                                            onClick={() => {this.setThreeDotMenuOpen(null)}}>X</ThreeDotMenuClose>
                                        <ThreeDotMenuItem hidden={!this.props.lesson_id}>
                                            <FontAwesomeIcon className="fas fa-share-square" onClick={(e) => {
                                            e.preventDefault();
                                            api().post('/share', {
                                                type: 'note',
                                                id: this.props.lessonNotes[item].id,
                                                session_id: this.props.lesson_id
                                            }).then((response) => {
                                                if(response.data.success) {
                                                     toast.success('Success! Note shared!', {
                                                        position: "top-right",
                                                        autoClose: 5000,
                                                        hideProgressBar: true,
                                                        closeOnClick: true,
                                                    });
                                                    this.props.pullNotes(true, this.props.studentPaginationMeta.current_page);
                                                }
                                            });
                                        }}></FontAwesomeIcon>Share
                                        </ThreeDotMenuItem>
                                        <ThreeDotMenuItem hidden={!this.props.lessonNotes[item].can_delete}
                                                          onClick={() => {this.props.editNoteAction(this.props.lessonNotes[item].id)}}>
                                            <FontAwesomeIcon
                                                edit={true} className="fas fa-edit"></FontAwesomeIcon>
                                            Edit
                                        </ThreeDotMenuItem>
                                        <ThreeDotMenuItem
                                            onClick={() => {this.props.viewNoteAction(this.props.lessonNotes[item].id)}}>
                                            <FontAwesomeIcon className="fas fa-eye"></FontAwesomeIcon>
                                            View
                                        </ThreeDotMenuItem>
                                        <ThreeDotMenuItem hidden={!this.props.lessonNotes[item].can_delete}
                                                          onClick={() => {this.props.togglePinAction(this.props.lessonNotes[item].id); this.setThreeDotMenuOpen(null);}}>
                                            <FontAwesomeIcon className="fas fa-thumbtack"></FontAwesomeIcon>
                                            {this.props.lessonNotes[item].favorite ? 'Unpin' : 'Pin to top'}
                                        </ThreeDotMenuItem>
                                        <ThreeDotMenuItem no_border={true}>
                                            <FontAwesomeIcon hidden={!this.props.lessonNotes[item].can_delete} onClick={(e) => {
                                e.preventDefault();
                                var r = confirm("Are you sure you want to delete the Note?");
                                if (r == true) {

                                  api().delete('/notes/'+this.props.lessonNotes[item].id).then((response) => {
                                    this.props.pullNotes(true, this.props.studentPaginationMeta.current_page);
                                  });
                                }
                            }} className="fas fa-trash"></FontAwesomeIcon>
                                            Delete
                                        </ThreeDotMenuItem>
                                    </ThreeDotMenu>


                                </NoteHeading> <NoteSubheading>

                                <SharedLabel
                                    full={this.props.lessonNotes[item].full_label+' - '+this.props.lessonNotes[item].created_at}
                                    short={this.props.lessonNotes[item].short_label+' - '+this.props.lessonNotes[item].created_at}>
                                </SharedLabel>
                            </NoteSubheading>

                                <NoteContent className="note-content"
                                             dangerouslySetInnerHTML={{__html: sanitizeNoteHtml(this.props.lessonNotes[item].content)}}></NoteContent>
                                {this.props.lessonNotes[item].video ? (
                                    <NoteVideo>{"Video"} - 1:15</NoteVideo>
                                ) : (
                                    <></>
                                )}
                                {this.props.lessonNotes[item].pdf ? (
                                    <NotePdf>{"PDF"}</NotePdf>
                                ) : (
                                    <></>
                                )}
                            </Note>
                        ))}
                    </NotesList>


                    <Pagination>
                        {this.props.studentPaginationMeta ? (
                            <>
                            <PaginationRefresh
                                onClick={() => {this.props.pullNotes(false, this.props.studentPaginationMeta.current_page)}}>Refresh
                                results</PaginationRefresh>
                            <Pages className="pagination-pages">
                                {this.props.studentPaginationMeta.links.map((item, index) => (
                                    <React.Fragment key={index}>
                                    {(item.label == '...' || (index > 0 && (item.label !== '<' && item.label !== '>' && index <= item.label))) ? (
                                        <span index={index}
                                              className={this.props.studentPaginationMeta.current_page - 1 == item.label || this.props.studentPaginationMeta.current_page + 1 == item.label || item.active || item.label == '...' || index == 0 || index == 1 || index == 2 || item.label == this.props.studentPaginationMeta.last_page || item.label == this.props.studentPaginationMeta.last_page - 1 || item.label == this.props.studentPaginationMeta.last_page - 2 ? 'visible pagination-page-wrapper' : 'pagination-page-wrapper'}
                                              key={index}>
                                        <Page className="pagination-page"
                                              onClick={() => {this.props.pullNotes(false, item.label);}}
                                              active={item.active}>{item.label}</Page>
                                        </span>
                                    ) : (
                                        <>
                                        {(index == 0) ? (


                                            <span index={index}
                                                  className={'visible pagination-page-wrapper'}
                                                  key={index}>
                                            <PageArrow
                                                className="visible"
                                                onClick={() => {this.props.pullNotes(false, this.props.studentPaginationMeta.current_page == 1 ? 1 : this.props.studentPaginationMeta.current_page - 1);}}>
                                                {"<"}
                                            </PageArrow>
                                            </span>
                                        ) : (

                                            <span index={index}
                                                  className={'visible pagination-page-wrapper'}
                                                  key={index}>
                                            <PageArrow
                                                className="visible"
                                                onClick={() => {this.props.pullNotes(false, this.props.studentPaginationMeta.current_page == this.props.studentPaginationMeta.last_page ? this.props.studentPaginationMeta.last_page : this.props.studentPaginationMeta.current_page + 1);}}>
                                                {">"}
                                            </PageArrow>
                                            </span>
                                        )}
                                        </>
                                    )}
                                    </React.Fragment>
                                ))}
                            </Pages>
                            </>
                        ) : (
                            <></>
                        )}
                    </Pagination>
                </TabContent>
                <TabContent open={this.state.tab_open === 2}>
                    <TabContentLoading open={this.props.notesLoading}><i
                        className="fa fa-spinner"></i></TabContentLoading>
                    <MenuButton onClick={this.props.newNoteAction}>
                        <AddIcon src={AddIconSrc}/>
                        {"Create New Note"}
                    </MenuButton>
                    <MenuSearchInput onKeyDown={this.props.searchMyNotes} onChange={this.props.searchMyNotes}
                                     placeholder="Search Notes"></MenuSearchInput>


                    <SortWrapper>
                        <SortLabel>Sort By:</SortLabel>
                        <SortInputWrapper>
                            <MenuSelect onChange={(e) => {this.props.selectSort(e, 'myNotes')}}>
                                <ModalOption value="created_at">Created Date</ModalOption>
                                <ModalOption value="name">Name</ModalOption>
                            </MenuSelect>
                        </SortInputWrapper>
                    </SortWrapper>

                    {this.props.paginationMeta ? (
                        <PaginationResults>showing {this.props.yourNotes.length} of {this.props.paginationMeta.total} results</PaginationResults>
                    ) : (
                        <></>
                    )}
                    <NotesList>
                        {Object.keys(this.props.yourNotes).map((item, index) => (
                            <Note key={this.props.yourNotes[item].id}>
                                <NoteHeading>
                                    <NoteName>
                                        {this.props.yourNotes[item].favorite && (
                                            <FontAwesomeIcon className="fas fa-thumbtack" style={{marginRight:'6px'}}></FontAwesomeIcon>
                                        )}
                                        {this.props.yourNotes[item].name}
                                    </NoteName>

                                    <ThreeDotMenuTrigger
                                        onClick={() => {this.setThreeDotMenuOpen(this.props.yourNotes[item].id)}}
                                        src={ThreeDotMenuIcon}></ThreeDotMenuTrigger>
                                    <ThreeDotMenu
                                        open={this.state.three_dot_menu_open == this.props.yourNotes[item].id}>
                                        <ThreeDotMenuClose
                                            onClick={() => {this.setThreeDotMenuOpen(null)}}>X</ThreeDotMenuClose>
                                        <ThreeDotMenuItem hidden={!this.props.lesson_id}>
                                            <FontAwesomeIcon className="fas fa-share-square" onClick={(e) => {
                                            e.preventDefault();
                                            api().post('/share', {
                                                type: 'note',
                                                id: this.props.yourNotes[item].id,
                                                session_id: this.props.lesson_id
                                            }).then((response) => {
                                                if(response.data.success) {
                                                     toast.success('Success! Note shared!', {
                                                        position: "top-right",
                                                        autoClose: 5000,
                                                        hideProgressBar: true,
                                                        closeOnClick: true,
                                                    });
                                                        this.props.pullNotes(false, this.props.paginationMeta.current_page);
                                                    
                                                }
                                            });
                                        }}></FontAwesomeIcon>Share
                                        </ThreeDotMenuItem>
                                        <ThreeDotMenuItem hidden={!this.props.yourNotes[item].can_delete}
                                                          onClick={() => {this.props.editNoteAction(this.props.yourNotes[item].id)}}>
                                            <FontAwesomeIcon

                                                edit={true} className="fas fa-edit"></FontAwesomeIcon>
                                            Edit
                                        </ThreeDotMenuItem>
                                        <ThreeDotMenuItem
                                            onClick={() => {this.props.viewNoteAction(this.props.yourNotes[item].id)}}>
                                            <FontAwesomeIcon className="fas fa-eye"></FontAwesomeIcon>
                                            View
                                        </ThreeDotMenuItem>
                                        <ThreeDotMenuItem hidden={!this.props.yourNotes[item].can_delete}
                                                          onClick={() => {this.props.togglePinAction(this.props.yourNotes[item].id); this.setThreeDotMenuOpen(null);}}>
                                            <FontAwesomeIcon className="fas fa-thumbtack"></FontAwesomeIcon>
                                            {this.props.yourNotes[item].favorite ? 'Unpin' : 'Pin to top'}
                                        </ThreeDotMenuItem>
                                        <ThreeDotMenuItem no_border={true}>
                                            <FontAwesomeIcon hidden={!this.props.yourNotes[item].can_delete} onClick={(e) => {
                                e.preventDefault();
                                var r = confirm("Are you sure you want to delete the Note?");
                                if (r == true) {

                                  api().delete('/notes/'+this.props.yourNotes[item].id).then((response) => {
                                    this.props.pullNotes(false, this.props.paginationMeta.current_page);
                                  });
                                }
                            }} className="fas fa-trash"></FontAwesomeIcon>
                                            Delete
                                        </ThreeDotMenuItem>
                                    </ThreeDotMenu>


                                </NoteHeading> <NoteSubheading>

                                <SharedLabel
                                    full={this.props.yourNotes[item].full_label+' - '+this.props.yourNotes[item].created_at}
                                    short={this.props.yourNotes[item].short_label+' - '+this.props.yourNotes[item].created_at}>
                                </SharedLabel>
                            </NoteSubheading>

                                <NoteContent className="note-content"
                                             dangerouslySetInnerHTML={{__html: sanitizeNoteHtml(this.props.yourNotes[item].content)}}></NoteContent>
                                {this.props.yourNotes[item].video ? (
                                    <NoteVideo>{"Video"} - 1:15</NoteVideo>
                                ) : (
                                    <></>
                                )}
                                {this.props.yourNotes[item].pdf ? (
                                    <NotePdf>{"PDF"}</NotePdf>
                                ) : (
                                    <></>
                                )}
                            </Note>
                        ))}
                    </NotesList>


                    <Pagination>
                        {this.props.paginationMeta ? (
                            <>
                            <PaginationRefresh
                                onClick={() => {this.props.pullNotes(false, this.props.paginationMeta.current_page)}}>Refresh
                                results</PaginationRefresh>
                            <Pages className="pagination-pages">
                                {this.props.paginationMeta.links.map((item, index) => (
                                    <React.Fragment key={index}>
                                    {(item.label == '...' || (index > 0 && (item.label !== '<' && item.label !== '>' && index <= item.label))) ? (
                                        <span index={index}
                                              className={this.props.paginationMeta.current_page - 1 == item.label || this.props.paginationMeta.current_page + 1 == item.label || item.active || item.label == '...' || index == 0 || index == 1 || index == 2 || item.label == this.props.paginationMeta.last_page || item.label == this.props.paginationMeta.last_page - 1 || item.label == this.props.paginationMeta.last_page - 2 ? 'visible pagination-page-wrapper' : 'pagination-page-wrapper'}
                                              key={index}>
                                        <Page className="pagination-page"
                                              onClick={() => {this.props.pullNotes(false, item.label);}}
                                              active={item.active}>{item.label}</Page>
                                        </span>
                                    ) : (
                                        <>
                                        {(index == 0) ? (


                                            <span index={index}
                                                  className={'visible pagination-page-wrapper'}
                                                  key={index}>
                                            <PageArrow
                                                className="visible"
                                                onClick={() => {this.props.pullNotes(false, this.props.paginationMeta.current_page == 1 ? 1 : this.props.paginationMeta.current_page - 1);}}>
                                                {"<"}
                                            </PageArrow>
                                            </span>
                                        ) : (

                                            <span index={index}
                                                  className={'visible pagination-page-wrapper'}
                                                  key={index}>
                                            <PageArrow
                                                className="visible"
                                                onClick={() => {this.props.pullNotes(false, this.props.paginationMeta.current_page == this.props.paginationMeta.last_page ? this.props.paginationMeta.last_page : this.props.paginationMeta.current_page + 1);}}>
                                                {">"}
                                            </PageArrow>
                                            </span>
                                        )}
                                        </>
                                    )}
                                    </React.Fragment>
                                ))}
                            </Pages>
                            </>
                        ) : (
                            <></>
                        )}
                    </Pagination>
                </TabContent>
            </NoteMenuWrapper>
        );
    }
}
